// @ts-strict-ignore
import React from 'react';
import { Badge, Tooltip } from '@usealloy/component-library';
import { getStrengthBadgeTooltip, getStrengthBadgeType } from '../helpers';

type MatchStrengthBadgeProps = {
  service: string;
  strength: number | null;
};

type MatchStrengthBadgeTooltipProps = MatchStrengthBadgeProps & { children: React.ReactElement };

const MatchStrengthTooltipWrapper = ({
  service,
  strength,
  children,
}: MatchStrengthBadgeTooltipProps) => {
  const tooltipContent = service === 'ComplyAdvantage'
    ? getStrengthBadgeTooltip(strength)
    : 'Match Strength';

  return (
    <Tooltip
      content={tooltipContent}
      side="top"
    >
      {children}
    </Tooltip>
  );
};

const MatchStrengthBadge = ({
  service,
  strength,
}: MatchStrengthBadgeProps) => (
  <MatchStrengthTooltipWrapper {...{ service, strength }}>
    <Badge status={getStrengthBadgeType(service, strength)}>{strength ?? '--'}</Badge>
  </MatchStrengthTooltipWrapper>
);

export default MatchStrengthBadge;
